// Experience
// Features:
// - Main scene composition and layout
// - Manages physics world, environment, and core game loops
// - Orchestrates phase-dependent components via WhenPhase

import { Physics } from '@react-three/rapier'

import { PHASES } from './store/usePhase.js'

import CameraController from './components/Camera/CameraController.jsx'
import CameraRayOutside from './components/CameraRayOutside.jsx'
import CameraRayInside from './components/CameraRayInside.jsx'
import CharacterController from './components/CharacterController.jsx'

import Cabin from './components/Cabin/Cabin.jsx'
import Terrain from './components/Outside/Terrain.jsx'
import Snow from './components/Snow.jsx'
import Smoke from './components/Smoke.jsx'
import WindSound from './components/WindSound.jsx'

import Logo from './components/Logo.jsx'
import FadeOverlay from './components/FadeOverlay.jsx'
import Pointer from './components/Pointer.jsx'
import WhenPhase from './components/WhenPhase.jsx'
import PostFx from './components/PostFx.jsx'

export default function Experience() {
    return (
        <>
            <CameraController />

            <Terrain />

            {/* Physics World */}
            <Physics debug={false}>
                <Cabin />

                {/* Outside Interactions */}
                <WhenPhase includes={[PHASES.menuIdle]}>
                    <CameraRayOutside />
                </WhenPhase>

                {/* Inside Player & Interactions */}
                <WhenPhase includes={[PHASES.inCabin]}>
                    <CharacterController />
                </WhenPhase>
                <WhenPhase includes={[PHASES.inCabin]}>
                    <CameraRayInside />
                    <Pointer />
                </WhenPhase>
            </Physics>

            <Snow />

            {/* Outside Effects */}
            <WhenPhase excludes={[PHASES.inCabin]}>
                <Logo />
                <Smoke />
            </WhenPhase>

            {/* Global Overlay & Audio */}
            <FadeOverlay />
            <WhenPhase excludes={[PHASES.loading, PHASES.warmup]}>
                <WindSound />
            </WhenPhase>

            <PostFx />
        </>
    )
}
